<template>
  <NuxtLayout class="flex">
    <main class="text-center container flex flex-col min-h-full w-full max-w-md items-center justify-center py-12">
      <h1 class="text-6xl text-copper-900 font-extrabold mb-0">404</h1>
      <h2 class="text-3xl font-extrabold mb-8">Page not found</h2>

      <p class="mb-8">The page you are looking for does not exist.</p>
      <p>
        Try going back or emailing
        <VLink component="a" href="mailto:support@vrify.com" target="_blank" class="text-copper-700" font-weight="normal">
          support@vrify.com
        </VLink>
        if you believe this might be an error.
      </p>

      <VButton class="mt-12 w-full" component="a" href="/" variant="dark" size="md">Go back home</VButton>
    </main>
  </NuxtLayout>
</template>

<script lang="ts" setup>
defineProps({
  error: {
    type: Object,
    required: true,
  },
})
</script>
